import DBOperations from "src/utils/dbOperations";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
// import craneLayout from "@/assets/crane.json";
// import capstanLayout from "@/assets/capstan.json";
// import entrecLayout from "@/assets/entrec.json";

async function getPdfLayout(config) {
  try {
    let res = await DBOperations.fetchData(
      Constants.enums.TABLES_NAME_ENUM.PDF_LAYOUTS_TABLE,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField,
      config.sortOrder,
      config.page,
      config.rows,
      config.fetchAll,
      config.queryParams
    );
    // res.data[0].content = craneLayout;
    // res.data[0].content = capstanLayout;
    // res.data[0].content = entrecLayout;
    // console.log("res >>> ", res);
    return res;
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getAddOnPdfLayouts(config) {
  try {
    return await DBOperations.fetchData(
      Constants.enums.TABLES_NAME_ENUM.PDF_ADDON_LAYOUTS_TABLE,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField,
      config.sortOrder,
      config.page,
      config.rows,
      config.fetchAll,
      config.queryParams
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}
export default {
  getPdfLayout,
  getAddOnPdfLayouts
};
